import { render, staticRenderFns } from "./DashboardSupplierDueTable.vue?vue&type=template&id=2dd40778"
import script from "./DashboardSupplierDueTable.vue?vue&type=script&lang=ts"
export * from "./DashboardSupplierDueTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports